import Table from 'react-bootstrap/Table';

const tablaModal = ({row})=> {

    return (
        <div>
            <Table striped hover responsive size="sm" style={{fontSize: '0.8em'}}>
                <tbody>
                    <tr>
                        <th colSpan={2} style={{textAlign: 'center'}}>Información colaborador</th>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Nombre colaborador</td>
                        <td style={{width: '60%'}}>{row.NOMBRECOLABORADOR}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Proyecto</td>
                        <td style={{width: '60%'}}>{row.NOMBREPROYECTO}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Etapa</td>
                        <td style={{width: '60%'}}>{row.NOMBREETAPA}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Tarea</td>
                        <td style={{width: '60%'}}>{row.NOMBRETAREA}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Fecha</td>
                        <td style={{width: '60%'}}>{row.FECHA}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Horas</td>
                        <td style={{width: '60%'}}>{row.HORAS}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Actividades</td>
                        <td style={{width: '60%'}}>{row.ACTIVIDAD}</td>
                    </tr>
                    <tr>
                        <th colSpan={2} style={{textAlign: 'center'}}>Información supervisor</th>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Estatus</td>
                        <td style={{width: '60%'}}>{row.ESTATUS_CH}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Observaciones</td>
                        <td style={{width: '60%'}}>{row.OBSERVACIONES_CH}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Fecha de aprobación</td>
                        <td style={{width: '60%'}}>{row.FAPROBACIONCH}</td>
                    </tr>
                    <tr>
                        <th colSpan={2} style={{textAlign: 'center'}}>Información departamento</th>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Estatus</td>
                        <td style={{width: '60%'}}>{row.ESTATUS_DEPTO}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Observaciones</td>
                        <td style={{width: '60%'}}>{row.OBSERVACIONES}</td>
                    </tr>
                    <tr>
                        <td style={{width: '40%'}}>Fecha de modificación</td>
                        <td style={{width: '60%'}}>{row.FMODIFICACION}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
}

export default tablaModal;